import {request} from '../lib/apiRequestWrapper';

const SET_DEALERS = "DEALERS/SET_DEALERS";
const SET_LOADING = "DEALERS/SET_LOADING";

export function fetchDealers() {
  return (dispatch, getState) => {
    dispatch({type: SET_LOADING, payload: true});
    return new Promise((resolve, reject) => {
      
      return request(
        process.env.RAZZLE_GQLAPI,
        {
          method: "POST",
          body: JSON.stringify({
            query: /* GraphQL */`query ($skip: Int, $sort: LocationDtoSortInput!, $filter: LocationDtoFilterInput) {
              locationList(skip: $skip, take: 50, order: [$sort], where: $filter) {
                items {
                  id locationId name state
                  dealer {
                    dealerCode dealerId name
                  }
                }
                totalCount
              }
            }`,
            variables: {
              skip: 0,
              sort: {name: "ASC"},
              filter: {type: {eq: "Sales"}, status: {eq: true}}
            }
          })
        }
      ).then(response => {
        // console.log(response);
        let items = response.data?.locationList?.items;
        if (items?.length > 0) {
          dispatch({type: SET_DEALERS, payload: items});
        } else {
          dispatch({type: SET_LOADING, payload: false});
        }
        resolve();
      }).catch(err => {
        // console.log(err);
        dispatch({type: SET_LOADING, payload: false});
        resolve();
      });
    });
  }
}

const defaultState = {
  isLoading: false,
  salesLocations: null
};

export function dealersReducer(state = defaultState, action) {
  switch (action.type) {

    case SET_LOADING:
    return Object.assign({}, state, {
      isLoading: action.payload
    });

    case SET_DEALERS:
    return Object.assign({}, state, {
      salesLocations: action.payload,
      isLoading: false
    });

    default:
    return state;
  }
}
